// extracted by mini-css-extract-plugin
module.exports = {"monthHeader":"QuranicCalendarMonth_monthHeader__yK_65","container":"QuranicCalendarMonth_container__Nxg83"};